import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { Carousel } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const CategoriesCarousel = ({ className, isLoading, error, data }) => {
    const navigate = useNavigate();
    const [index, setIndex] = useState(0);
    const categories = !isLoading && !error ? data.records : [];

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    return (
        <Carousel className={className} activeIndex={index} onSelect={handleSelect}>
            {categories.map((category) => (
                <Carousel.Item key={category.id} interval={5000}>
                    {
                        <div className="bg-primary bg-gradient text-light py-5">
                            <div className="carousel-item-wrapper">
                                <div className="row">
                                    <div className="col-md-6 col-lg-4 col-xl-3">
                                        <div className="d-flex justify-content-center align-items-center w-100 h-100">
                                            <i className={`fad fa-${category.icon} fa-10x`}></i>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-lg-8 col-xl-9">
                                        <h3 className="h2 mt-3">{category.name}</h3>
                                        <p className="card-text">{category.description}</p>
                                        <div className="row">
                                            <button
                                                className="btn btn-outline-light btn-lg col-4 offset-4 mt-3 mb-5"
                                                onClick={() =>
                                                    navigate(`/search?category=${category.name}`)
                                                }>
                                                Buy
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </Carousel.Item>
            ))}
        </Carousel>
    );
};

CategoriesCarousel.propTypes = {
    className: PropTypes.string,
    isLoading: PropTypes.bool,
    error: PropTypes.string,
    data: PropTypes.object
};

CategoriesCarousel.defaultProps = {
    className: '',
    isLoading: true,
    error: null,
    data: null
};
